import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PriceService } from '../../price/price.service';
import { OrderState } from 'app/order/models/order-state.model';
import { getOrderStateTag } from 'app/order/fns';
import { ProductsService } from 'app/products/products.service';
import { OrderStepsService } from 'app/order/order-step.service';
import { InsuranceTypesService } from '@core';

@Component({
    selector: 'app-order-summary',
    templateUrl: './order-summary.component.html',
    styleUrl: './order-summary.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class OrderSummaryComponent {
    public state = input<OrderState>();

    private orderStepsService = inject(OrderStepsService);

    protected product = inject(ProductsService).product;
    protected price = inject(PriceService).price;
    protected insuranceType = inject(InsuranceTypesService).insuranceType;

    private monthlySettlementPeriodTag = getOrderStateTag('hasMonthlySettlementPeriod') as Signal<boolean>;

    protected hasMonthlySettlementPeriod = computed(() => {
        const tag = this.monthlySettlementPeriodTag();
        if (tag !== undefined) {
            return tag;
        }
        return this.insuranceType().settlementPeriod === 'month';
    });

    protected isCompany = computed(() => this.state()?.billingAddress?.title?.id === environment.titleCompanyId);

    protected isAppliance = computed(() => this.state()?.insuredObjects[0]?.type === 'Haushaltsgerät');

    protected isSmartphone = computed(() => this.state()?.insuredObjects[0]?.type === 'Smartphone');

    protected goToStep(step: string): void {
        this.orderStepsService.setStep(step);
    }
}
